import axios from "axios";
import { Response } from "@/shared/models/Response";
import { CampusPagination } from "../models/CampusPagination";
import { CampusQuery } from "../models/CampusQuery";
import { CampusModel } from "../models/CampusModel";
import { CampusSpaceModel } from "../../../shared/models/CampusSpaceModel";
import { CampusIdName } from "../models/CampusIdName.Model";

export class CampusService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_SCHEDULING_API}/campus`;
  }

  async getCampusById(id: string): Promise<Response<CampusModel>> {
    const serviceUrl = `${this.baseUrl}/${id}`;
    const response = await axios.get(serviceUrl);
    return response.data;
  }

  async getCampusByFilter(
    query: CampusQuery
  ): Promise<Response<CampusPagination>> {
    const serviceURL = `${this.baseUrl}/find-by-filters`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async updateStateCampus(
    id: string,
    state: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/state/${id}/${state}`;
    const response = await axios.put(serviceUrl);
    return response.data;
  }

  async addCampus(campus: CampusModel): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}`;
    const response = await axios.post(serviceUrl, campus);
    return response.data;
  }

  async updateCampus(
    id: string,
    campus: CampusModel
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/${id}`;
    const response = await axios.put(serviceUrl, campus);
    return response.data;
  }

  async deleteCampus(id: string): Promise<Response<string | void>> {
    return (await axios.delete(`${this.baseUrl}/${id}`)).data;
  }

  async getAllCampus(): Promise<Response<void | CampusSpaceModel[]>> {
    return (await axios.get(`${this.baseUrl}/`)).data;
  }

  async getAllCampusWithExtraInfo(): Promise<Response<void | CampusModel[]>> {
    return (await axios.get(`${this.baseUrl}/all-campus`)).data;
  }

  async checkIfExistByName(name: string): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/exist-by-name`;

    const params = {
      params: {
        nameCampus: name
      }
    };

    const response = await axios.get(serviceURL, params);
    return response.data;
  }

  async getCampusByAvailabilityTemplateId(
    id: string
  ): Promise<Response<CampusIdName[]>> {
    const serviceURL = `${this.baseUrl}/find-campus-by-availability-template/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }
}
